import {
  SupportedLanguageLocales,
  findFirstSupportedLanguageWithRegionAgnosticFallbackOrDefault,
  getUserPreferredBrowserLanguages,
  localeToLanguageRegionString,
} from "../Localization";
import { getQueryFlag } from "../UserShowOptions";

// taken from Strings.GlassPaneLoading in Strings.*.resx
const LocalizedLoadingLabels: { [key in SupportedLanguageLocales]: string } = {
  "de-DE": "Wird geladen…",
  "en-US": "Loading...",
  "en-GB": "Loading...",
  "es-ES": "Cargando...",
  "fr-FR": "Chargement en cours...",
  "fr-CA": "Chargement en cours...",
  "it-IT": "Caricamento in corso...",
  "ja-JP": "読み込んでいます...",
  "ko-KR": "로드 중...",
  "nl-NL": "Laden…",
  "pt-BR": "Carregando...",
  "sv-SE": "Läser in ...",
  "th-TH": "กำลังโหลด...",
  "zh-CN": "正在加载...",
  "zh-TW": "正在載入...",
};

export function showSpinner(doc: Document) {
  const displaySpinner = getQueryFlag(":display_spinner", true);
  const displayOverlay = getQueryFlag(":display_overlay", true);

  if (displaySpinner) {
    const loadingSpinner = doc.getElementById("loadingSpinner");
    if (loadingSpinner) {
      const preferredLanguages = getUserPreferredBrowserLanguages();
      const locale =
        findFirstSupportedLanguageWithRegionAgnosticFallbackOrDefault(
          preferredLanguages
        );
      const ariaLabel =
        LocalizedLoadingLabels[
          localeToLanguageRegionString(locale) as SupportedLanguageLocales
        ] ?? LocalizedLoadingLabels["en-US"];

      loadingSpinner
        .querySelector(`[role="img"]`)
        ?.setAttribute("aria-label", ariaLabel);

      loadingSpinner.style.removeProperty("display");
    }
  }
  if (displayOverlay) {
    const glassPane = doc.getElementById("loadingGlassPane");
    if (glassPane) {
      glassPane.style.removeProperty("display");
    }
  }
}
